module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ToolsView.js"));
	}, "ToolsView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ToolsView!./src/pages/Learn/Tools/ToolsView.js
// module id = 2231
// module chunks = 367